var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16699 6.76187C2.16699 3.49585 4.77033 0.833008 8.00033 0.833008C11.2303 0.833008 13.8337 3.49585 13.8337 6.76187C13.8337 8.33861 13.3843 10.0316 12.5899 11.4943C11.7966 12.9551 10.6374 14.2245 9.18733 14.9023C8.43406 15.2543 7.56659 15.2543 6.81332 14.9023C5.36324 14.2245 4.20407 12.9551 3.4107 11.4943C2.61635 10.0316 2.16699 8.33861 2.16699 6.76187ZM8.00033 1.83301C5.33928 1.83301 3.16699 4.03133 3.16699 6.76187C3.16699 8.15994 3.56875 9.68994 4.28946 11.017C5.01115 12.3458 6.03101 13.4327 7.23673 13.9963C7.72172 14.223 8.27892 14.223 8.76393 13.9963C9.96966 13.4327 10.9895 12.3458 11.7112 11.017C12.4319 9.68994 12.8337 8.15994 12.8337 6.76187C12.8337 4.03133 10.6614 1.83301 8.00033 1.83301ZM8.00033 5.16634C7.17193 5.16634 6.50033 5.83791 6.50033 6.66634C6.50033 7.49474 7.17193 8.16634 8.00033 8.16634C8.82873 8.16634 9.50033 7.49474 9.50033 6.66634C9.50033 5.83791 8.82873 5.16634 8.00033 5.16634ZM5.50033 6.66634C5.50033 5.28563 6.61961 4.16634 8.00033 4.16634C9.38106 4.16634 10.5003 5.28563 10.5003 6.66634C10.5003 8.04707 9.38106 9.16634 8.00033 9.16634C6.61961 9.16634 5.50033 8.04707 5.50033 6.66634Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.4b6fbcd1fda3166eef4b30ffadf7a3f0.svg";
export { ForwardRef as ReactComponent };